import { render } from "./KapitelfragenQuizPage_A_Plus.vue?vue&type=template&id=0cb7333e"
import script from "./KapitelfragenQuizPage_A_Plus.vue?vue&type=script&lang=js"
export * from "./KapitelfragenQuizPage_A_Plus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__